import { render, staticRenderFns } from "./EditTableMenu.vue?vue&type=template&id=0fcc0ba6&"
import script from "./EditTableMenu.vue?vue&type=script&lang=ts&"
export * from "./EditTableMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports